import {isEqual} from 'lodash';

/*
 * Check if every element in the array is equal to the first element, by value.
 */
export const isBoringArray = (arr: any[]) => {
  const firstVal = arr[0];
  if (Array.isArray(arr)) {
    return arr.every(val => isEqual(val, firstVal));
  }
  return false;
};
